export const logError = (error: unknown, description?: string) => {
  console.error(`[Error]: ${description}`, error);

  throw error;
};
